<template>
  <div>
    <AstronomerProfileSection :slug="slug" />
    <AstronomerChartSection :slug="slug" />
    <AstronomerTargetsSection :slug="slug" />
    <AstronomerSessionsSection :slug="slug" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AstronomerProfileSection from '../components/AstronomerProfileSection.vue'
import AstronomerChartSection from '../components/AstronomerChartSection.vue'
import AstronomerTargetsSection from '../components/AstronomerTargetsSection.vue'
import AstronomerSessionsSection from '../components/AstronomerSessionsSection.vue'

const route = useRoute()
const slug = computed(() => route.params.slug as string)
</script>
